'use client';

import { useSelector } from 'react-redux';
import PageScrollManager from '@/components/layout/PageScrollManager';
import DashboardActivityGate from '@/components/dashboard/DashboardActivityGate';
import {
  shellSidebarMainContentMarginClass,
  shellSidebarTransitionClass,
} from '@/lib/layout/shellSidebarLayout';

/**
 * Content margin matches the sidebar via CSS classes (ml-12 / lg:ml-16|64).
 * Avoids the old useState(48) → desktop 256px jump that inflated CLS on first paint.
 * Margin transition only after sidebar hydrate so the initial layout does not animate.
 */
export default function MainContent({ children }) {
  const { isCollapsed, isHydrated, isMobileSidebarOpen } = useSelector(
    (state) => state.sidebar,
  );

  const marginClass = shellSidebarMainContentMarginClass(
    isMobileSidebarOpen,
    isCollapsed,
    isHydrated,
  );

  return (
    <div
      className={`flex h-dvh max-h-dvh min-h-0 min-w-0 max-w-full flex-col overflow-hidden ${marginClass} ${
        isHydrated ? shellSidebarTransitionClass : ''
      }`}
    >
      <PageScrollManager />
      <DashboardActivityGate />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {children}
      </div>
    </div>
  );
}
